import { getComponentClasses } from '@99designs/common/utils/app/index';
import classNames from 'classnames';
import BriefStepHeading from 'projects/components/SmartShoot/BriefStepHeading';
import React from 'react';

interface Props {
    step: number;
    heading: string;
    subheading: React.ReactNode;
    rightAlignImage?: boolean;
    variations?: string[];
    hideImage?: boolean;
    required?: boolean;
    briefType?: 'video' | 'photo';
}

export default class BriefStep extends React.Component<Props> {
    public static defaultProps: Partial<Props> = {
        rightAlignImage: false,
        hideImage: false,
        required: false,
    };

    render() {
        const briefStepClasses = classNames(
            getComponentClasses('brief-step', this.props.variations),
            {
                'brief-step--invert-cols': this.props.rightAlignImage,
            }
        );

        return (
            <div className={briefStepClasses}>
                {!this.props.hideImage && this.renderImage()}
                <div className="brief-step__form">
                    <BriefStepHeading
                        step={this.props.step}
                        heading={this.props.heading}
                        subHeading={this.props.subheading}
                        required={this.props.required}
                    />
                    {this.props.children}
                </div>
            </div>
        );
    }

    private renderImage() {
        return (
            <div className="brief-step__image-container">
                <img
                    className="brief-step__image-container__image"
                    src={require(`images/smartshoot/ss-${this.props.briefType}-brief0${
                        this.props.step
                    }.jpg`)}
                />
            </div>
        );
    }
}
